<template>
    <div class="col-md-6 col-lg-4">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">Editar Equipe</h3>
            </div>
            <form v-on:submit.prevent="edit">
                <div class="panel-body">
                    <div class="form-group">
                        <label class="form-group" for="name">Nome</label>
                        <input class="form-control" type="text" v-model="team.name" placeholder="Nome" name="name" id="name">
                        <span class="text-danger">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="leaders">Lideres</label>
                        <v-select :reduce="leader => leader.id" label="name" v-model="leaders" :options="options.leaders" multiple/>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="employees">Liderados</label>
                        <v-select :reduce="employee => employee.id" label="name" v-model="employees" :options="options.employees" multiple/>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Editar</button>
                    </div>
                </div>
            </form>
        </div>
    </div>


</template>

<script>
    import axios from 'axios'
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';

    export default {
        name: 'team-edit',
        props: ['team'],
        data () {
            return {
                errors: {},
                leaders: [],
                employees: [],
                options: {
                    employees:[],
                    leaders: []
                }
            }
        },
        mounted () {
            this.leaders = this.team.leaders_ids
            this.employees = this.team.employees_ids
            axios
                .get('/api/users/role/employee')
                .then((response) => {
                    this.options.employees = response.data.data
                })
            axios
                .get('/api/users/role/leader')
                .then((response) => {
                    this.options.leaders = response.data.data
                })
        },
        methods: {
            edit () {
                axios
                    .put('/api/teams/' + this.team.id, {
                        name: this.team.name,
                        employees: this.employees,
                        leaders: this.leaders
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'teams'
                        });
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
            }
        }
    }
</script>


<style scoped lang="sass">
    .btn-primary
        margin-top: 30px
    .mx-datepicker
        display: block
        width: 100%
</style>
